export default __webpack_public_path__ + "static/media/group_FCC.08449216.jpg";